$(document).ready(function (params) {
  $(document).on('click', '#wear-options .design-item', function () {
    const $this = $(this);
    const value = $this.data('value');

    $('#wear-options .design-item').removeClass('selected');
    $this.addClass('selected');
    $('#wear-value').text($this.find('.sr-only').text());

    const isLooseGem = value === 'loose-gemstone';
    $('#design-options, #metal-options').toggle(!isLooseGem);
    $('#metal-input').val(isLooseGem ? '' : '18k Gold');
    $('#design-input, #design-prod').val(isLooseGem ? '' : undefined);

    const fields = {
      '#design-prod': 'items[1][id]',
      '#design-qty': 'items[1][quantity]',
      '#design-gemstone': 'items[1][properties][Gemstone]',
      '#design-gem-sku': 'items[1][properties][Gemstone SKU]'
    };

    $.each(fields, (selector, name) => {
      isLooseGem ? $(selector).removeAttr('name') : $(selector).attr('name', name);
    });

    if(!isLooseGem) {
      if (!sessionStorage.getItem("goldNoticeShown")) {
        $("#gold-warning-popup").css("display", "flex");
        sessionStorage.setItem("goldNoticeShown", "true");
      }
    }

    $('#ring-size-selector').toggle(value === 'ring');
    $('#ring-size-system').prop('required', value === 'ring');

    updateDesigns($('#metal-options .design-item.selected').data('value'), value);
  });

  $(".gold-close").on("click", function () {
    $("#gold-warning-popup").hide();
  });

  $(".gold-close, .gold-ok-btn").on("click", function () {
    $("#gold-warning-popup").hide();
  });

  $(window).on("click", function (e) {
    if ($(e.target).is("#gold-warning-popup")) {
      $("#gold-warning-popup").hide();
    }
  });

  $(document).on('click', '#metal-options .design-item', function () {
    $('#metal-options .design-item').removeClass('selected');
    $(this).addClass('selected');

    const value = $(this).attr('data-value');
    $('#metal-input').val(value);

    const wear = $('#wear-options .design-item.selected').attr('data-value');
    updateDesigns(value, wear);
  });

  $(document).on('click', '.design-options .design-item', function () {
    $('.design-options .design-item').removeClass('selected');
    $(this).addClass('selected');

    const value = $(this).attr('data-value');
    const variantId = $(this).attr('data-var-id');
    $('#design-input').val(value);
    $('#design-prod').val(variantId);

    $('.design-options .design-container').addClass('hide');
    $('#selected-design').addClass('active');

    /*const optionText = $(this).find('p').text();
    var imgURL = $(this).find('.design-item-image').attr('style')
    imgURL = imgURL.replace('--swatch-background: url(', 'https://').replace(')', '');
    $('.selected-design-content').html(`You Have Selected <span id="selected-option">${optionText}</span> Click <span id="change-design">HERE</span> to change your preference. You can opt to have your gemstone in a Ring or a Necklace`);
    $('.selected-design-image img').attr('src', imgURL);*/

    const optionText = $(this).attr('data-value');
    const selectedMetal = $('#metal-options .design-item.selected').attr('data-value');
    var imgURL = $(this).find('.design-item-image').attr('style');
    imgURL = imgURL.replace('--swatch-background: url(', 'https://').replace(')', '');

    if ( selectedMetal === '18k Gold' || selectedMetal === '22k Gold' || selectedMetal === 'Panchdhatu') {
      $('.selected-design-content').html(`You have selected <span id="selected-option">${optionText}</span>. An advance amount of ₹21,000 has been paid only for order booking and confirmation. This is not the full payment for the gold jewellery. You can opt to have your gemstone in a Ring or a Necklace. Click <span id="change-design">HERE</span> to change your preference.`);
    } else {
      $('.selected-design-content').html(`You Have Selected <span id="selected-option">${optionText}</span> Click <span id="change-design">HERE</span> to change your preference. You can opt to have your gemstone in a Ring or a Necklace`);
    }
  });

  $(document).on('click', '#change-design', function () {
    $('#design-input, #design-prod').val('');
    $('.design-options .design-item').removeClass('selected');
    $('.design-options .design-container').removeClass('hide');
    $('#selected-design').removeClass('active');
    $('.selected-design-content').html('');
    $('.selected-design-image img').attr('src', '');
  });

  function updateDesigns(metal, wear) {
    const $designOptions = $('#design-options');
    const gemName = $designOptions.attr('data-gem_name');
    const ringOptions = $designOptions.attr('data-ring_options').split(',');
    const pandentOptions = $designOptions.attr('data-pandent_options').split(',');

    if (wear === 'loose-gemstone') return;

    metal = metal.toLowerCase();
    if (metal.includes('gold')) {
      metal = 'gold';
    }

    let productHandle = `${metal}-${wear}`;
    if (metal !== 'gold' &&  wear === 'ring') {
      productHandle = `${metal}-${wear}-1`;
    }

    $.ajax({
      url: `/products/${productHandle}?view=design-options-html&gem=${gemName}`,
      type: 'GET',
      success: function (response) {
        // Create a temporary container to parse HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;

        // Get all design items
        const allDesignItems = tempDiv.querySelectorAll('.design-item');

        // Determine which options to allow based on wear
        const allowedOptions = wear === 'ring' ? ringOptions : pandentOptions;

        // // Track the first allowed item
        // let firstAllowedItem = null;

        // // Filter items based on data-value
        // allDesignItems.forEach(item => {
        //   const value = item.getAttribute('data-value');
        //   if (!allowedOptions.includes(value)) {
        //     item.remove(); // Remove unlisted items
        //   } else if (!firstAllowedItem) {
        //     firstAllowedItem = item; // Save the first allowed item
        //   }
        // });

// GET MAKING CHARGE DATA & Convert string to object
        const makingChargeData = $designOptions.attr('data-making-charge');
        const makingChargeMap = {};


        // Convert string to object
        if (makingChargeData) {
          makingChargeData.split(',').forEach(item => {
            const parts = item.split(':');
            if (parts.length >= 2) {
              const key = parts[0].trim();
              const value = parts[1].trim();
              makingChargeMap[key] = value;
            }
          });
        }


        // Track the first allowed item
        let firstAllowedItem = null;

        // Filter items based on data-value
        allDesignItems.forEach(item => {

          const value = item.getAttribute('data-value');

          if (!allowedOptions.includes(value)) {
            item.remove(); // Remove unlisted items
          } else if (!firstAllowedItem) {
            firstAllowedItem = item; // Save the first allowed item
          }

          // Find making charge
          const makingCharge = makingChargeMap[value];
          // Get selected metal
          const selectedMetal = $('#metal-options .design-item.selected').attr('data-value');
          const pTag = item.querySelector('p');

          // Add making charge after title
          // Show making charge only for ring + gold
          if ((wear === 'ring' || wear === 'pendant') && makingCharge && pTag && (selectedMetal === '18k Gold' || selectedMetal === '22k Gold')) {
            pTag.innerHTML = `${value} (21k Advance only) <span class="making-charge"> + ${makingCharge} Making Charges </span>`;
          }  
        });

        // Add 'selected' class to the first allowed item, if any
        if (firstAllowedItem) {
          firstAllowedItem.classList.add('selected');
        }

        // Inject filtered HTML into the DOM
        $designOptions.html(tempDiv.innerHTML);
        // $('.design-options .design-item.selected').click();
      },
      error: function (xhr, status, error) {
        console.error('Error loading design options:', error);
      }
    });
  }
});